import React from 'react';
import './OlimpoBannerMobile.css'
import { olimpoBanner } from '../OlimpoHostingBanner.tsx';

function OlimpoBannerMobile() {
    return(
        <a className='olimpo-hosting-brand-mobile' href='https://olimpohost.com/'>
            <img alt='Olimpo Hosting' src={olimpoBanner}/>
        </a>
    );
}

export default OlimpoBannerMobile;
